/**
 * JavaScript for Image Gallery with Sticky Scroll Effect
 * Creates stacking effect where items stick and scale down
 */

export default class ImageGallery {
  constructor(el) {
    this.$this = $(el);
    this.$gallery = this.$this.find('.gg-image-carousel__gallery');
    this.$items = this.$gallery.find('.gg-image-carousel__item');
    this.$images = this.$gallery.find('.gg-image-carousel__image');
    
    // Configuration
    this.stickyTops = [240, 320, 400]; // top-60, top-80, top-100 in px
    this.scaleRange = 0.2; // Scale from 1.0 to 0.8
    this.isScrolling = false; // Throttling flag
  }

  init() {
    this.initImageEvents();
    this.initStickyScroll();
    this.handleScroll();
  }

  initImageEvents() {
    // Add click events or other simple interactions
    this.$images.on('load', function() {
      // Image loaded successfully
      $(this).addClass('loaded');
    });

    // Optional: Add error handling
    this.$images.on('error', function() {
      console.warn('Failed to load image:', this.src);
    });
  }

  initStickyScroll() {
    // Set up initial states
    this.$items.each((index, item) => {
      const $item = $(item);
      $item.attr('data-index', index);
      
      // Set initial z-index (higher for later items so they stack on top)
      $item.css('z-index', 100 + index);
    });

    // Bind scroll event with throttling for smoother performance
    $(window).on('scroll.imageGallery', () => {
      if (!this.isScrolling) {
        this.isScrolling = true;
        requestAnimationFrame(() => {
          this.handleScroll();
          this.isScrolling = false;
        });
      }
    });
  }

  handleScroll() {
    const scrollTop = $(window).scrollTop();
    const overlapCount = Math.max(1, this.$items.length - 1);
    const scaleStep = this.scaleRange / overlapCount; // tổng giảm vẫn = 0.2
    const translateStep = 30 / overlapCount;
  
    this.$items.each((index, item) => {
      const $item = $(item);
      const itemTop = $item.offset().top;
      
      // Get sticky top for this specific item
      const stickyTop = this.stickyTops[index] || this.stickyTops[0];
      
      // Calculate if item should be sticky
      const stickyPoint = itemTop - scrollTop;
      const isSticky = stickyPoint <= stickyTop;
      
      if (isSticky) {
        // Calculate scale and transform based on scroll progress for smooth animation
        let totalScale = 1;
        let totalTranslateY = 0;
        
        // Check each item that comes after this one
        this.$items.each((i, otherItem) => {
          if (i > index) { // Items after this one
            const $otherItem = $(otherItem);
            const otherTop = $otherItem.offset().top;
            const otherStickyTop = this.stickyTops[i] || this.stickyTops[0];
            const otherStickyPoint = otherTop - scrollTop;
            
            // Start scaling when the other item is getting close to sticky position (starts overlapping)
            // Begin effect when the other item is within 120px of becoming sticky (increased for smoother transition)
            if (otherStickyPoint <= otherStickyTop + 520) {
              // Calculate progress: 
              // When otherStickyPoint = otherStickyTop + 120 (120px away), progress = 0
              // When otherStickyPoint = otherStickyTop (just sticky), progress = 0.5
              // When otherStickyPoint = otherStickyTop - 120 (120px past sticky), progress = 1
              const totalDistance = 140; // 120px before + 120px after sticky point (increased for longer transition)
              const distanceFromStart = (otherStickyTop + 300) - otherStickyPoint;
              let progress = Math.max(0, Math.min(1, distanceFromStart / totalDistance));
              
              // Apply easing function for smoother animation (ease-out)
              progress = 1 - Math.pow(1 - progress, 3); // Cubic ease-out
              
              console.log(`Item ${index} affected by item ${i}: stickyPoint=${otherStickyPoint.toFixed(1)}, stickyTop=${otherStickyTop}, progress=${progress.toFixed(2)}`);
              
              // Apply progressive scale and translation based on progress
             
              const scaleReduction = progress * scaleStep;
              const translateReduction = progress * translateStep;
              
              totalScale -= scaleReduction;
              totalTranslateY -= translateReduction;
            }
          }
        });
        
        // Ensure scale doesn't go below 0.7
        totalScale = Math.max(1 - this.scaleRange, totalScale);
        
        console.log(`Item ${index}: scale=${totalScale.toFixed(2)}, translateY=${totalTranslateY}px`);
        
        // Apply transforms to image only to preserve item layout
        const $image = $item.find('.gg-image-carousel__image');
        $image.css({
          'transform': `scale(${totalScale}) translateY(0) translateZ(0)`,
          'transition': 'none' // Remove transition for smooth scroll-based animation
        });
        
        // Set z-index on item for stacking
        $item.css({
          'z-index': 100 + index // Later items have higher z-index
        });
        
        $item.addClass('is-sticky');
        
      } else {
        // Reset transforms for non-sticky items with no transition for smoothness
        const $image = $item.find('.gg-image-carousel__image');
        $image.css({
          'transform': 'scale(1) translateY(0) translateZ(0)',
          'transition': 'none'
        });
        
        $item.css({
          'z-index': 100 + index
        });
        
        $item.removeClass('is-sticky');
      }
    });
  }

  destroy() {
    // Clean up event listeners
    this.$images.off('load error');
    $(window).off('scroll.imageGallery');
    
    // Reset transforms on images
    this.$images.css({
      'transform': '',
      'transition': ''
    });
    
    // Reset item properties
    this.$items.css({
      'z-index': '',
      'opacity': ''
    }).removeClass('is-sticky');
  }
}


$('.gg-image-carousel').each((_index, el) => {
  new ImageGallery(el).init();
});